import DemoModeSvc from "./demoModeSvc";
import { AccountData, AccountDataAPI } from "../models/AccountData";
import { FeatureDataConverter } from "../models/featureUseLimits/FeatureUseLimitsConverter";
import { LocalPostData } from "../models/LocalPostData";
import { LocationActivityLog } from "../models/LocationActivityLog";
import { LocationData } from "../models/LocationData";
import { LocationReviewSummary } from "../models/LocationReviewSummary";
import { MediaData } from "../models/MediaData";
import { OrganizationData } from "../models/OrganizationData";

const demoMode = DemoModeSvc.current;

// Class to use when manipulating data from the API to fit the front-end model
export class ApiDataConverter {
  static processAccountData(data: AccountDataAPI): AccountData {
    const convertedAccount = ApiDataConverter.convertAccountDataAPIToClient(data);

    const demoModeProcessedAccount = demoMode.isDemoModeOn
      ? demoMode.processAccount(convertedAccount)
      : convertedAccount;

    const convertFeatureUseLimits = FeatureDataConverter.convertUserData(
      demoModeProcessedAccount
    );

    return convertFeatureUseLimits;
  }

  /**
   * Transforms the AccountData model from the server into the shape that the client uses.
   */
  static convertAccountDataAPIToClient(data: AccountDataAPI): AccountData {
    // The last_login_at field is not needed, and causes many unnecessary rerenders.
    const { last_login_at, ...rest } = data;
    return {
      ...rest
    };
  }

  static processOrganizationData(data: OrganizationData): OrganizationData {
    const demoModeProcessedOrganization = demoMode.isDemoModeOn
      ? demoMode.processOrganization(data)
      : data;

    const convertFeatureUseLimits =
      FeatureDataConverter.convertOrganizationData(
        demoModeProcessedOrganization
      );

    return convertFeatureUseLimits;
  }

  static processLocationData(data: LocationData): LocationData {
    const demoModeProcessedLocation = demoMode.isDemoModeOn
      ? demoMode.processLocation(data)
      : data;

    const convertFeatureUseLimits = FeatureDataConverter.convertLocationData(
      demoModeProcessedLocation
    );

    return convertFeatureUseLimits;
  }

  static processLocalPostData(data: LocalPostData): LocalPostData {
    const demoModeProcessedLocalPost = demoMode.isDemoModeOn
      ? demoMode.processLocalPost(data)
      : data;

    return demoModeProcessedLocalPost;
  }

  static processMedia(data: MediaData): MediaData {
    const demoModeProcessedMedia = demoMode.isDemoModeOn
      ? demoMode.processMedia(data)
      : data;

    return demoModeProcessedMedia;
  }

  static processReview(review: any): any {
    return demoMode.isDemoModeOn ? demoMode.processReview(review) : review;
  }

  static processLocationReviewSummary(
    item: LocationReviewSummary
  ): LocationReviewSummary {
    return demoMode.isDemoModeOn
      ? demoMode.processLocationReviewSummary(item)
      : item;
  }

  static processActivityLogs(
    activityLogs: LocationActivityLog[]
  ): LocationActivityLog[] {
    return demoMode.isDemoModeOn
      ? demoMode.processActivityLogs(activityLogs)
      : activityLogs;
  }
}
